export enum EntityType {
  FONT = 'font',
  COLOR = 'color',
  PRODUCT = 'product',
  CATEGORY = 'category',
  FONT_GROUP = 'fontGroup',
  COLOR_GROUP = 'colorGroup',
  QUANTITY_BREAK = 'quantityBreak',
  SHOPIFY_PRODUCT = 'shopifyProduct',
  PRODUCTION_TIME = 'productionTime',
  PREORDER_PRODUCT = 'preorderProduct',
  PRODUCT_CATEGORY_OPTION = 'productCategoryOption',
  PRODUCT_CATEGORY_ATTRIBUTE = 'productCategoryAttribute',

  // fallback option (base type) used in CrudModule
  ENTITY = 'entity',
}
